import React, { useState } from 'react';
import { MenuIcon, XIcon, CalendarIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white sticky top-0 z-50 shadow-sm" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="flex justify-between items-center py-4 md:justify-start md:space-x-10" data-id="element-116">
          <div className="flex justify-start lg:w-0 lg:flex-1" data-id="element-117">
            <a href="/" className="font-bold text-2xl text-black-000" data-id="element-118">
              Mayhave Copy
            </a>
          </div>
          <div className="-mr-2 -my-2 md:hidden" data-id="element-119">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-green-700 hover:text-green-900 hover:bg-green-50 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-120">
              <span className="sr-only" data-id="element-121">Open menu</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-122" />
            </button>
          </div>
          <nav className="hidden md:flex space-x-10" data-id="element-123">
            <a href="/services" className="text-base font-medium text-gray-700 hover:text-green-700" data-id="element-124">
              Services
            </a>
            <a href="/process" className="text-base font-medium text-gray-700 hover:text-green-700" data-id="element-125">
              Process
            </a>
            <a href="/testimonials" className="text-base font-medium text-gray-700 hover:text-green-700" data-id="element-126">
              Testimonials
            </a>
            <a href="/portfolio" className="text-base font-medium text-gray-700 hover:text-green-700" data-id="element-127">
              Portfolio
            </a>
            <a href="/about" className="text-base font-medium text-gray-700 hover:text-green-700" data-id="element-128">
              About
            </a>
          </nav>
          <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0" data-id="element-129">
            <a href="https://calendly.com/mayhave/30min" className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-8 py-3 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-green-600 hover:bg-green-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-id="element-130">
              <CalendarIcon className="mr-2 h-5 w-5" data-id="element-131" />
              Book A Call 📞
            </a>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden" data-id="element-132">
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50" data-id="element-133">
            <div className="pt-5 pb-6 px-5" data-id="element-134">
              <div className="flex items-center justify-between" data-id="element-135">
                <div data-id="element-136">
                  <span className="font-bold text-xl text-green-700" data-id="element-137">
                    CopyPro
                  </span>
                </div>
                <div className="-mr-2" data-id="element-138">
                  <button type="button" className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={() => setIsMenuOpen(false)} data-id="element-139">
                    <span className="sr-only" data-id="element-140">Close menu</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-141" />
                  </button>
                </div>
              </div>
              <div className="mt-6" data-id="element-142">
                <nav className="grid gap-y-8" data-id="element-143">
                  <a href="/services" className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-144">
                    <span className="ml-3 text-base font-medium text-gray-900" data-id="element-145">
                      Services
                    </span>
                  </a>
                  <a href="/process" className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-146">
                    <span className="ml-3 text-base font-medium text-gray-900" data-id="element-147">
                      Process
                    </span>
                  </a>
                  <a href="/testimonials" className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-148">
                    <span className="ml-3 text-base font-medium text-gray-900" data-id="element-149">
                      Testimonials
                    </span>
                  </a>
                  <a href="/portfolio" className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-150">
                    <span className="ml-3 text-base font-medium text-gray-900" data-id="element-151">
                      Portfolio
                    </span>
                  </a>
                  <a href="/about" className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-152">
                    <span className="ml-3 text-base font-medium text-gray-900" data-id="element-153">
                      About
                    </span>
                  </a>
                </nav>
              </div>
            </div>
            <div className="py-6 px-5 space-y-6" data-id="element-154">
              <a href="https://calendly.com/mayhave/30min" className="w-full flex items-center justify-center px-8 py-3 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-green-600 hover:bg-green-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" onClick={() => setIsMenuOpen(false)} data-id="element-155">
                <CalendarIcon className="mr-2 h-5 w-5" data-id="element-156" />
                Get Started
              </a>
            </div>
          </div>
        </div>}
    </header>;
};